<template>
  <div class="home d-flex flex-column">
    <div class="banner">
      <img src="@/assets/logo.png" width="250" height="250" alt="Lyt-Soft Logo">
    </div>
  <div class="card shadow-lg rounded-3 py-3" style="border-radius:0; border:none">
    <div class="card-body p-1">
      <h1 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700">
        <span style="color: #4169e1">OT</span>P</h1>

      <form @submit.prevent="login2">
        <div class="form-floating mb-3">
          <input id="floatingPasswordInput"
                 v-model="otp"
                 class="form-control" placeholder="Enter OTP"
                 required type="text">
          <label for="floatingPasswordInput">Otp Number</label>
        </div>
        <div class="text-center">
          <p class="text-danger">{{ warning }}</p>
          <div style="display: block">
            <button :disabled="loading" class="login-btn primary" type="submit" style="margin-bottom: 5px;">
              Login
              <span v-if="loading" aria-hidden="true" class="spinner-grow spinner-grow-sm" role="status"></span>
            </button>

            <div class="resend-otp-wrapper">
              <button
                  class="login-btn primary"
                  @click.prevent="resendOtp"
                  :disabled="isResendDisabled"
                  :class="{ 'disabled-overlay': isResendDisabled }"
              >
                Resend Otp
                <span v-if="isResendDisabled">{{ resendTimer }}s</span>
                <span v-if="loadingOtp" aria-hidden="true" class="spinner-grow spinner-grow-sm" role="status"></span>
              </button>
              <div v-if="isResendDisabled" class="overlay"></div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'OTP',

  data() {
    return {
      otpData: {},
      loading: false,
      loadingOtp: false,
      show_password: false,
         otp: "",
      warning: '',
      isResendDisabled: false, // State for disabling the button
      resendTimer: 0, // Countdown timer
      timerInterval: null, // For clearing the interval
    }
  },
  methods: {

    login2() {
      this.loading = true;
      return this.$store.dispatch('verifyOtp', { otp : this.otp })
          .catch((err) => this.warning = err)
          .finally(() => this.loading = false);
    },
    resendOtp() {
      this.loadingOtp = true;
      this.otpData = this.$store.getters.getCurrentUser;
      this.$store.dispatch('userLogin', this.otpData);

      this.isResendDisabled = true;
      this.resendTimer = 60; // 60 seconds
      this.startTimer();
    },

    startTimer() {
      // Clear any existing interval to avoid conflicts
      clearInterval(this.timerInterval);

      // Start the countdown
      this.timerInterval = setInterval(() => {
        if (this.resendTimer > 0) {
          this.resendTimer--;
        } else {
          this.isResendDisabled = false;
          this.loadingOtp = false;
          clearInterval(this.timerInterval); // Clear the timer when it reaches 0
        }
      }, 1000); // Runs every 1 second
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card {
  padding-left: 10px;
  padding-right: 10px;
  width: 400px;
  max-width: 95vw;
  margin-top: -3rem !important;
}

.login-btn {
  color: white;
  display: block;
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 7px 18px rgba(11, 102, 255, 0.3) !important;

}
.home{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.resend-otp-wrapper {
  width: 100%;
  position: relative;
  display: inline-block;
}

/* Overlay specific to the Resend OTP button */
.resend-otp-wrapper .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4); /* Dark semi-transparent overlay */
  border-radius: 5px; /* Match the button's border radius */
  pointer-events: none; /* Allow clicks to pass through */
  z-index: 1; /* Ensure the overlay is above the button */
}

/* Style for the disabled button */
button:disabled {
  cursor: not-allowed;
  opacity: 0.6; /* Dim the button when disabled */
}
</style>
